import { FC } from 'react';
import { IconProps } from '../types';

export const PersonPlusIcon: FC<IconProps> = ({ width = '24', height = '20', className, color = '#4F5863' }) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox='0 0 26 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M16 19V17C16 15.9391 15.5786 14.9217 14.8284 14.1716C14.0783 13.4214 13.0609 13 12 13H5C3.93913 13 2.92172 13.4214 2.17157 14.1716C1.42143 14.9217 1 15.9391 1 17V19'
      stroke={color}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M8.5 9C10.7091 9 12.5 7.20914 12.5 5C12.5 2.79086 10.7091 1 8.5 1C6.29086 1 4.5 2.79086 4.5 5C4.5 7.20914 6.29086 9 8.5 9Z'
      stroke={color}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M20.5 4.96484V12.0359' stroke={color} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M24.0355 8.50038H16.9645' stroke={color} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);
